import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from '../../service/api.service'
import { API_HEARTBEAT_V1 } from '../../app-settings'
import { JobStatus, JobConfig, JobOverview, JobRunHistory } from '../../content/models/jobs'

@Injectable({
  providedIn: 'root',
})
export class HeartbeatApiService {
  constructor(private apiService: ApiService) {}

  public Job = {
    getStatusOverview: (): Observable<JobStatus[]> => this.apiService.get(API_HEARTBEAT_V1 + 'Job/Status'),
    
    getStatusDetails: (projectName: string, jobName: string, daysToGoBack: number = 3): Observable<any> =>
      this.apiService.get(API_HEARTBEAT_V1 + `Job/Project/${projectName}/Job/${jobName}?daysToGoBack=${daysToGoBack}`),

    getOverview: (limit = 10): Observable<JobOverview[]> => this.apiService.get(API_HEARTBEAT_V1 + `Job/Overview?limit=${limit}`),

    getRunHistory: (projectName: string, jobName: string, from: Date, to: Date): Observable<JobRunHistory> => {
      const iso = (d: Date) => d.toISOString().split('.')[0]
      return this.apiService.get(API_HEARTBEAT_V1 + `Job/Project/${projectName}/Job/${jobName}/Runs?from=${iso(from)}&to=${iso(to)}`)
    },

    getAllConfigs: (): Observable<JobConfig[]> => this.apiService.get(API_HEARTBEAT_V1 + 'Job/Config'),

    upsertConfig: (projectName: string, jobName: string, gracePeriodSeconds: number): Observable<any> =>
      this.apiService.put(API_HEARTBEAT_V1 + 'Job/Config', {
        ProjectName: projectName,
        JobName: jobName,
        GracePeriodSeconds: gracePeriodSeconds,
      }),

    deleteConfig: (projectName: string, jobName: string): Observable<any> => this.apiService.delete(API_HEARTBEAT_V1 + `Job/Project/${projectName}/Job/${jobName}/Config`),
    
    delete: (projectName: string, jobName: string): Observable<any> => this.apiService.delete(API_HEARTBEAT_V1 + `Job/Project/${projectName}/Job/${jobName}`),
  }
}
